import { render, staticRenderFns } from "./Graficos.vue?vue&type=template&id=ed66d6b0&scoped=true"
import script from "./Graficos.vue?vue&type=script&lang=js"
export * from "./Graficos.vue?vue&type=script&lang=js"
import style0 from "./Graficos.vue?vue&type=style&index=0&id=ed66d6b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed66d6b0",
  null
  
)

export default component.exports